@if (guidelineComponent(); as guidelineComponent) {
  @if (isMedicationTab()) {
    <div class="tt-sidebar-medications-tab">
      <span class="tt-sidebar-medications-tab_title">{{ 'Medication' | transloco }}</span>

      <div class="tt-sidebar-medications-tab_list">
        @for (medication of guidelineComponent.medicationRequests; track medication.id) {
          <tt-medication-card
            [medication]="medication"
            (deleteClicked)="deleteMedication(medication.id)"
            (editClicked)="openEditDialog(medication)" />
        }
      </div>

      <div class="tt-sidebar-medications-tab_actions">
        <button aria-label="{{ 'Sidebar.AddMedication' | transloco }}" ttButton variant="secondary" (click)="openAddMedicationDialog()">
          <mat-icon [icon]="'plus'" />
          {{ 'Sidebar.AddNew' | transloco }}
        </button>
      </div>
    </div>
  } @else {
    <div class="tt-sidebar-medications">
      <div class="tt-sidebar-medications_header">
        <span class="tt-sidebar-medications_header-title">{{ 'Medication' | transloco }}:</span>

        <button
          aria-label="{{ 'Sidebar.AddMedication' | transloco }}"
          emphasis="minimal"
          size="icon"
          ttButton
          variant="transparent"
          (click)="openAddMedicationDialog()">
          <mat-icon [icon]="'circle-plus-filled'" [iconSize]="18" />
        </button>
      </div>

      <div class="tt-sidebar-medications_list">
        @for (medication of guidelineComponent.medicationRequests.slice(0, 3); track medication.id) {
          <tt-medication-card
            [medication]="medication"
            (deleteClicked)="deleteMedication(medication.id)"
            (editClicked)="openEditDialog(medication)" />
        }
      </div>

      @if (medicationRequestsCount() > 3) {
        <div class="tt-sidebar-medications_actions">
          <button size="xSmall" ttButton variant="transparent" [routerLink]="" (click)="showAllMedications()">
            {{ 'Sidebar.ShowAllMedications' | transloco: { medicationCount: medicationRequestsCount() } }}
          </button>
        </div>
      }
    </div>
  }
}
